import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Jul 15 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { WindowChangeDTOConverter, ForecastChangeWindowDTOConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var ForecastChangeLayer =
/*#__PURE__*/
function () {
  function ForecastChangeLayer() {
    var _this = this;

    _classCallCheck(this, ForecastChangeLayer);

    /**
     * Get changed products based on windowId and snapshot date
     * @param windowId
     * @param snapshotDate
     * @returns Promise<WindowChangeDTO>
     */
    this.getProductsDifference = function (windowId, snapshotDate) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.FORECAST_CHANGE_REPORT_PRODUCTS(windowId)).post({
                  snapshotDate: snapshotDate
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this2.windowChangeDTOConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
  }
  /**
   * Get changed windows based on filter values
   * @param filter
   * @returns Promise<ForecastChangeWindowDTO[]>
   */


  _createClass(ForecastChangeLayer, [{
    key: "getWindows",
    value: function getWindows(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api(CONSTANTS.API.ENDPOINTS.FORECAST_CHANGE_REPORT_WINDOWS).post(filter, {
                  responseType: 'json'
                }).then(function (response) {
                  return (response.data.result || []).map(function (i) {
                    return _this3.forecastChangeWindowDTOConverter.toObject(i, jsonConversions);
                  });
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return ForecastChangeLayer;
}();

__decorate([Inject, __metadata("design:type", ForecastChangeWindowDTOConverter)], ForecastChangeLayer.prototype, "forecastChangeWindowDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowChangeDTOConverter)], ForecastChangeLayer.prototype, "windowChangeDTOConverter", void 0);